import {Fragment, useEffect, useState} from "react";
import { IPageData } from "../../interfaces/page";
import { usePageData } from '../../hooks/usePage';
import KRGlue from "@lyracom/embedded-form-glue";
import { useParams } from "react-router-dom";
import { message } from "antd";
import Loading from "../../components/Loading";
import PublicLayout from "../../layout/public/Public";
import moment from "moment";
import "../styles/formulario.css";

const pageData: IPageData = {
  fulFilled: true,
  title: 'Pago de Servicio',
  breadcrumbs: [
    // {
    //   title: 'Home',
    //   route: 'pago'
    // },
    {
      title: 'Pago de Servicio',
    }
  ]
};

const FormularioPago = () => {
  usePageData(pageData);
  const [loading, setLoading] = useState(true)
  const [factura, setFactura] = useState({
    ap_nom:'',
    medico:'',
    id_tipdoc: '',
    nume_doc:'',
    Parv_Descripcion:'',
    fecha_atencion:'',
    Email: ''
  })
  /**************EL ID_FACTU DE LA URL******************** */
  const {id_factu}: {id_factu: string} = useParams();

  useEffect(() => {
    getTicketById(id_factu)
  }, []);

  const getTicketById = async(id_factu) => {
    try {
      await fetch(`${process.env.REACT_APP_HOSTNAME}/getTicketById/${id_factu}`)
      .then(res => res.json())
      .then(data => {
        // console.log(data)
        if (data.message) {
          message.error('El ticket Solicitado ya se ha Pagado')
          const interval = setInterval(() => { 
            window.location.href='https://limatambo.com.pe/'
          }, 3000);
          return () => clearInterval(interval);
        }else {
          setFactura(data)
          cargarFormulario(data)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const cargarFormulario = async(ticket) =>{

    const order = {
      amount: ticket.Monto_Paciente*100,
      currency: "PEN",
      orderId: ticket.id_tipdoc+"-"+ticket.nume_doc,
      customer: {
          email: ticket.Email,
          phoneNumber: ticket.Telefono,
          cellPhoneNumber: ticket.celular
      }
    };

    try {
      await fetch(`${process.env.REACT_APP_HOSTNAME}/CreatePayment`,{
        method: "POST",
        body: JSON.stringify(order),
        headers:{
          'Content-Type': 'application/json',//,para poder enviar un JSON
          'Access-Control-Allow-Origin': '*'
        }
      }).then(res => res.json())
      .then(data => {
        // console.log(data)
        if (data.status === 'SUCCESS') {
          KRGlue.loadLibrary('https://static.micuentaweb.pe',
          `${process.env.REACT_APP_PUBLIC_KEY}`)
          .then(({KR}) => {
            setLoading(false)
            KR.setFormToken(data.answer.formToken)
            KR.setFormConfig(({
              'kr-post-url-success': `https://pacientes.limatambo.com.pe/cita/CitaAutorizada/${id_factu}`
              // 'kr-post-url-refused': 'http://localhost:4000/pagado'
            }))
            KR.onSubmit(onPaid)
            KR.onError(onerror)
          })
        } else {
          message.error('ERROR: '+ data.answer.errorCode + ' ' + data.answer.errorMessage)
        }
      }).catch(err => console.log(err));
    } catch (error) {
      console.log(error)
    }
  }

  const onerror = async(event) => {
    const transacciones = event.metadata.answer.clientAnswer.transactions

    for (let i = 0; i < transacciones.length; i++) {
      const body = {...transacciones[i], id_factu: id_factu}
      try {
        await fetch(`${process.env.REACT_APP_HOSTNAME}/AddTransaccionFront`,{
          method: "POST",
          body: JSON.stringify(body),
          headers:{
            'Content-Type': 'application/json'
          }
        })  
      } catch (error) {
        console.log(error)
      }
    }
  }

  const onPaid = async(event) => {
    if (event.clientAnswer.orderStatus === "PAID") {
      // Remove the payment form
      //KR.removeForms();
      const transacciones = event.clientAnswer.transactions
      // console.log(transacciones)
      for (let i = 0; i < transacciones.length; i++) {
        const body = {...transacciones[i], id_factu: id_factu}
        try {
          await fetch(`${process.env.REACT_APP_HOSTNAME}/AddTransaccionFront`,{
            method: "POST",
            body: JSON.stringify(body),
            headers:{
              'Content-Type': 'application/json'
            }
          })  
        } catch (error) {
          console.log(error)
        }
      }
      // Show success message
      document.getElementById("paymentSuccessful").style.display = "block";
      return true;
    } else {
      // Show error message to the user
      alert("Payment failed !");
      return false;
    }
  }

  if (loading == true) {
    return(
      <PublicLayout bgImg={`${window.origin}/content/imgFormPasarela.jpeg`}>
        <Loading/>
      </PublicLayout>
    )
  } else {
    return(
      <PublicLayout bgImg={`${window.origin}/content/imgFormPasarela.jpeg`}>
        <div style={{display:"flex", justifyContent:"center"}}>
          <label style={{fontSize:'20px', fontWeight:'bold', textDecorationLine: 'underline'}}>
            Formulario de Pago Virtual 
          </label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Servicio:</label>  
          <label className="label-datos-muestra-form">{factura.Parv_Descripcion}</label>
        </div>
        
        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Paciente:</label>
          <label className="label-datos-muestra-form">{factura.ap_nom}</label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Correo:</label>
          <label className="label-datos-muestra-form">{factura.Email}</label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Dr(a).:</label>
          <label className="label-datos-muestra-form">{factura.medico}</label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Fecha de atención:</label>
          <label className="label-datos-muestra-form">{moment.utc(factura.fecha_atencion).format('DD/MM/YYYY')}</label>
        </div>

        <div className="row-datos_form">
          <label className="label-datos-title-muestra-form">Orden N°:</label>
          <label className="label-datos-muestra-form">{factura.nume_doc}</label>
        </div>

        <div style={{display:"flex", justifyContent:"center"}}>
          <div id="paymentForm" className="kr-embedded" kr-popin='true'
          /*kr-form-token="DEMO-TOKEN-TO-BE-REPLACED"*/>
            {/* <div className="kr-email">
              <input type="text" name="acme-email" placeholder="email" className="kr-theme" kr-icon="fas fa-envelope" required/>
            </div> */}
            <div className="kr-pan"></div>
            <div className="kr-expiry"></div>
            <div className="kr-security-code"></div>
            <div className="kr-installment-number" style={{display: 'none'}}></div>
            <div className="kr-first-installment-delay" style={{display: 'none'}}></div>
            <button className="kr-payment-button" style={{width:"100%"}}></button>
            <div className="kr-form-error"></div>
          </div>  
        </div>
        
      </PublicLayout>
    )
  }
  
}

export default FormularioPago